import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { StyleHelper, FormHelper } from "utils";
import {
  TerminalPOS,
  TIPO_VENTA_CONTADO,
  TIPO_VENTA_CREDITO,
  TIPO_VENTA_TODOS,
  TIPO_VENTA_CONTADO_LABEL,
  TIPO_VENTA_CREDITO_LABEL,
  TIPO_VENTA_TODOS_LABEL,
  TIPO_FACTURACION_RETAIL,
  TIPO_FACTURACION_GASOLINERA,
  TIPO_FACTURACION_RETAIL_LABEL,
  TIPO_FACTURACION_GASOLINERA_LABEL,
} from "models/ECF/TerminalPOS";
import { SideInput } from "components/Inputs/SideBar/SideInput";
import RadioGroup from "components/RadioGroup/RadioGroup";
import { CurrencyInput } from "components/PantallasEdit/CurrencyInput/CurrencyInput";
import InputContainer from "components/PantallasEdit/InputContainer/InputContainer";
import DropZone from "components/DropZone/Dropzone";
import IconButton from "components/IconButton/IconButton";
import SectionRow from "components/PantallasEdit/SectionRow/SectionRow";
import EditSection from "components/PantallasEdit/EditSection/EditSection";
import { PerfilLookup } from "components/Lookups/PerfilLookup/PerfilLookup";
import { VendedorLookup } from "components/Lookups/VendedorLookup/VendedorLookup";
import EditContainer from "components/PantallasEdit/EditContainer/EditContainer";
import ToolTip from "components/ToolTip/ToolTip";
import { useAuthentication } from "hooks";

const TerminalPOSEdit = ({ terminalPOS, setTerminalPOS }) => {
  const handlePerfilChange = (event) => {
    if (event && event.value && event.value !== terminalPOS.PerfilId) {
      setTerminalPOS({
        ...terminalPOS,
        PerfilId: event.value,
      });
    } else {
      setTerminalPOS({
        ...terminalPOS,
        PerfilId: undefined,
      });
    }
  };
  const { usuario } = useAuthentication();
  const CARDNET_ID = 8335;
  const mostrarConfiguracionCardNet =
    usuario?.CompaniaId === CARDNET_ID ||
    usuario?.Compania?.CompaniaTenantId === CARDNET_ID;
  const onFileChange = (files) => {
    setTerminalPOS({ ...terminalPOS, Img: files, _EliminarImagen: (files?.length ?? 0) === 0, ImagenBase64: null });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTerminalPOS({
      ...terminalPOS,
      [name]: value,
    });
  };

  return (
    terminalPOS !== undefined && (
      <Col>
        <Form action="" className="form-horizontal" id="TypeValidation" method="">
          <EditContainer>
            <EditSection title={"Información General"} style={{}}>
              <SectionRow>
                <InputContainer stacked label="Nombre" labelClassName={"d-flex"}>
                  <Form.Control
                    type="text"
                    name="NombreDispositivo"
                    value={terminalPOS?.NombreDispositivo || ""}
                    onChange={handleChange}
                    placeholder="Nombre"
                    style={StyleHelper.InputRequired}
                  />
                </InputContainer>

                <InputContainer stacked label="Modelo" labelClassName={"d-flex"}>
                  <Form.Control
                    readOnly
                    value={terminalPOS?.ModeloDispositivo || ""}
                    style={StyleHelper.InputRequired}
                  />
                </InputContainer>
              </SectionRow>

              <SectionRow>
                <InputContainer stacked label="Versión de SDK" labelClassName={"d-flex"}>
                  <Form.Control
                    readOnly
                    value={terminalPOS?.VersionSDK || ""}
                    style={StyleHelper.InputRequired}
                  />
                </InputContainer>

                <InputContainer stacked label="Versión de Android" labelClassName={"d-flex"}>
                  <Form.Control
                    readOnly
                    value={terminalPOS?.VersionFirmware || ""}
                    style={StyleHelper.InputRequired}
                  />
                </InputContainer>
              </SectionRow>

              <SectionRow>
                <InputContainer stacked label="IMEI" labelClassName={"d-flex"}>
                  <Form.Control
                    readOnly
                    value={terminalPOS?.IMEI || ""}
                    style={StyleHelper.InputRequired}
                  />
                </InputContainer>

                <InputContainer stacked label="Estatus" labelClassName={"d-flex"}>
                  <RadioGroup
                    name="Estatus"
                    options={TerminalPOS.ESTATUS_LIST}
                    selectedOption={terminalPOS?.Estatus || TerminalPOS.DEFAULT_ESTATUS_VALUE}
                    disabled={true}
                  />
                </InputContainer>
              </SectionRow>
            </EditSection>

            <EditSection title={"Información de la Tienda"} style={{}}>
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                {terminalPOS?.ImagenBase64 ? (
                  <InputContainer
                    labelClassName={'d-flex'}
                    rowStyle={{ width: '100%', display: 'flex', justifyContent: 'center' }}
                    style={{ display: 'flex', justifyContent: 'center', width: '100%', textAlign: 'center' }}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', gap: '1rem' }}>
                      <div>
                        <img src={
                          terminalPOS.ImagenBase64?.startsWith("data:image")
                            ? terminalPOS.ImagenBase64
                            : `data:image/png;base64,${terminalPOS.ImagenBase64}`
                        } alt="Imagen seleccionada"
                          style={{ maxWidth: "250px", maxHeight: "250px" }} />
                      </div>

                      <IconButton styles={{ height: '2.5rem' }}  >
                        <i className="fa fa-trash" onClick={() => setTerminalPOS({ ...terminalPOS, ImagenBase64: null, _EliminarImagen: true })}></i>
                      </IconButton>
                    </div>

                  </InputContainer>
                ) : (
                  <InputContainer
                    label="Logo"
                    labelClassName={'d-flex'}
                    ignoreColPadding={true}
                    rowStyle={{ display: 'flex', justifyContent: 'center', width: '100%' }}
                    style={{ display: 'flex', justifyContent: 'center', width: '100%', textAlign: 'center' }}>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
                      <DropZone
                        className=""
                        label="Seleccionar Imagen"
                        updateFilesCb={onFileChange}
                        multiple={false}
                        type="image" />
                    </div>
                  </InputContainer>
                )}
              </div>


              <SectionRow>
                <InputContainer stacked label="Nombre Comercial" labelClassName={"d-flex"}>
                  <Form.Control
                    type="text"
                    name="NombreComercial"
                    value={terminalPOS?.NombreComercial || ""}
                    onChange={handleChange}
                    placeholder="Nombre Comercial"
                    style={StyleHelper.InputRequired}
                  />
                </InputContainer>

                <InputContainer stacked label="Dirección" labelClassName={"d-flex"}>
                  <Form.Control
                    type="text"
                    name="Direccion"
                    value={terminalPOS?.Direccion || ""}
                    onChange={handleChange}
                    placeholder="Dirección"
                    style={StyleHelper.InputRequired}
                  />
                </InputContainer>
              </SectionRow>

              <SectionRow>
                <InputContainer stacked label="Teléfono" labelClassName={"d-flex"}>
                  <Form.Control
                    type="text"
                    name="Telefono"
                    value={terminalPOS?.Telefono || ""}
                    onChange={handleChange}
                    placeholder="Teléfono"
                    style={StyleHelper.InputRequired}
                  />
                </InputContainer>

                <InputContainer stacked label="Email" labelClassName={"d-flex"}>
                  <Form.Control
                    type="text"
                    name="Email"
                    value={terminalPOS?.Email || ""}
                    onChange={handleChange}
                    placeholder="Email"
                  />
                </InputContainer>
              </SectionRow>
            </EditSection>

            {mostrarConfiguracionCardNet && (
              <EditSection title={"Configuración CardNet"} style={{}}>
                <SectionRow>
                  <InputContainer stacked label="Merchant ID" labelClassName={"d-flex"}>
                    <Form.Control
                      type="text"
                      name="MerchantId"
                      value={terminalPOS?.MerchantId || ""}
                      onChange={handleChange}
                      placeholder="Merchant ID"
                    />
                  </InputContainer>

                  <InputContainer stacked label="Clave de seguridad" labelClassName={"d-flex"}>
                    <Form.Control
                      type="text"
                      inputMode="numeric"
                      name="ClaveSeguridad"
                      value={terminalPOS?.ClaveSeguridad || ""}
                      onChange={(e) => FormHelper.handleChangeSoloNumero(e, setTerminalPOS)}
                      placeholder="Clave de seguridad"
                    />
                  </InputContainer>
                </SectionRow>

                <SectionRow multilinea>
                  <InputContainer labelClassName={"d-flex"}>
                    <Form.Check
                      id="PermitirCobrosConTarjeta"
                      type="checkbox"
                      name="PermitirCobrosConTarjeta"
                      checked={terminalPOS?.PermitirCobrosConTarjeta || false}
                      onChange={(e) =>
                        setTerminalPOS({
                          ...terminalPOS,
                          PermitirCobrosConTarjeta: e.target.checked
                        })
                      }
                      label="Activar Integración con App de Cobro de CardNET"
                    />
                  </InputContainer>
                </SectionRow>
              </EditSection>
            )}

            <EditSection title={"Configuración General"} style={{}}>
              <SectionRow>
                <InputContainer stacked label="Perfil" labelClassName={"d-flex"}>
                  <PerfilLookup
                    initialValue={{ value: terminalPOS.PerfilId }}
                    onChange={handlePerfilChange}
                    setState={setTerminalPOS}
                    required
                  />
                </InputContainer>

                <InputContainer stacked label="Vendedor" labelClassName={"d-flex"}>
                  <VendedorLookup
                    initialValue={{ value: terminalPOS.VendedorId }}
                    onChange={(e) =>
                      setTerminalPOS({
                        ...terminalPOS,
                        VendedorId: e?.value,
                      })}
                  />
                </InputContainer>
              </SectionRow>

              <SectionRow columns={4}>
                <InputContainer stacked label="Tipo de Comercio" labelClassName={"d-flex"}>
                  <RadioGroup
                    name="TipoFacturacion"
                    options={TerminalPOS.TIPO_FACTURACION_LIST}
                    selectedOption={terminalPOS?.TipoFacturacion || TerminalPOS.TIPO_FACTURACION_LIST[0].value}
                    onChange={(e) =>
                      setTerminalPOS({
                        ...terminalPOS,
                        TipoFacturacion: e.target.value,
                        PedirPlaca: false
                      })
                    }
                  />
                </InputContainer>

                {terminalPOS?.TipoFacturacion != TIPO_FACTURACION_RETAIL && (
                  <InputContainer labelClassName={"d-flex"}>
                    <ToolTip message="Solicitar Placa de Vehículo">
                      <span>
                        <Form.Check
                          id="PedirPlaca"
                          type="checkbox"
                          name="PedirPlaca"
                          checked={terminalPOS?.PedirPlaca || false}
                          onChange={(e) =>
                            setTerminalPOS({
                              ...terminalPOS,
                              PedirPlaca: e.target.checked
                            })
                          }
                          label="Solicitar Placa"
                        />
                      </span>
                    </ToolTip>
                  </InputContainer>
                )}

                <InputContainer stacked label="Tipo de Venta" labelClassName={"d-flex"}>
                  <div style={{ display: "flex", gap: "1.5rem" }}>
                    <Form.Check
                      id="EsContado"
                      label="Contado"
                      type="checkbox"
                      name="TipoVenta"
                      checked={((terminalPOS?.TipoVenta || TerminalPOS.TIPO_VENTA_LIST[0].value) == TIPO_VENTA_CONTADO) ||
                        ((terminalPOS?.TipoVenta || TerminalPOS.TIPO_VENTA_LIST[0].value) == TIPO_VENTA_TODOS)
                      }
                      onChange={(e) => {
                        const current = terminalPOS?.TipoVenta || TerminalPOS.TIPO_VENTA_LIST[0].value;
                        const newContado = e.target.checked;
                        const newCredito = current == TIPO_VENTA_CREDITO || current == TIPO_VENTA_TODOS;
                        if (!newContado && !newCredito) return;
                        const TipoVenta = newContado && newCredito
                          ? TIPO_VENTA_TODOS
                          : newContado ? TIPO_VENTA_CONTADO : TIPO_VENTA_CREDITO;
                        setTerminalPOS({ ...terminalPOS, TipoVenta });
                      }}
                    />

                    <Form.Check
                      id="EsCredito"
                      label="Crédito"
                      type="checkbox"
                      name="TipoVenta"
                      checked={((terminalPOS?.TipoVenta || TerminalPOS.TIPO_VENTA_LIST[0].value) == TIPO_VENTA_CREDITO) ||
                        ((terminalPOS?.TipoVenta || TerminalPOS.TIPO_VENTA_LIST[0].value) == TIPO_VENTA_TODOS)
                      }
                      onChange={(e) => {
                        const current = terminalPOS?.TipoVenta || TerminalPOS.TIPO_VENTA_LIST[0].value;
                        const newCredito = e.target.checked;
                        const newContado = current == TIPO_VENTA_CONTADO || current == TIPO_VENTA_TODOS;
                        if (!newContado && !newCredito) return;
                        const TipoVenta = newContado && newCredito
                          ? TIPO_VENTA_TODOS
                          : newContado ? TIPO_VENTA_CONTADO : TIPO_VENTA_CREDITO;
                        setTerminalPOS({ ...terminalPOS, TipoVenta });
                      }}
                    />
                  </div>
                </InputContainer>
              </SectionRow>

              <SectionRow columns={4}>
                <InputContainer labelClassName={"d-flex"}>
                  <ToolTip message="Imprimir Automáticamente">
                    <span>
                      <Form.Check
                        id="ImprimirAutomaticamente"
                        type="checkbox"
                        name="ImprimirAutomaticamente"
                        checked={terminalPOS?.ImprimirAutomaticamente || false}
                        onChange={(e) =>
                          setTerminalPOS({
                            ...terminalPOS,
                            ImprimirAutomaticamente: e.target.checked
                          })
                        }
                        label="Auto Impresión"
                      />
                    </span>
                  </ToolTip>
                </InputContainer>

                <InputContainer labelClassName={"d-flex"}>
                  <ToolTip message="Solicitar Código de Vendedor">
                    <span>
                      <Form.Check
                        id="SolicitarCodigoVendedor"
                        type="checkbox"
                        name="SolicitarCodigoVendedor"
                        checked={terminalPOS?.SolicitarCodigoVendedor || false}
                        onChange={(e) =>
                          setTerminalPOS({
                            ...terminalPOS,
                            SolicitarCodigoVendedor: e.target.checked
                          })
                        }
                        label="Solicitar Código"
                      />
                    </span>
                  </ToolTip>
                </InputContainer>
              </SectionRow>
            </EditSection>

            <EditSection title={"Monto Límite por Comprobante"} style={{}}>
              <SectionRow columns={4}>
                <InputContainer stacked label="Consumidor Final" >
                  <CurrencyInput
                    name="MontoLimite2"
                    placeholder="Límite Consumidor Final"
                    value={terminalPOS?.MontoLimite2}
                    onChange={(numericValue) => {
                      setTerminalPOS({
                        ...terminalPOS,
                        MontoLimite2: numericValue,
                      });
                    }}
                  />
                </InputContainer>

                <InputContainer stacked label="Crédito Fiscal" >
                  <CurrencyInput
                    name="MontoLimite1"
                    placeholder="Límite Crédito Fiscal"
                    value={terminalPOS?.MontoLimite1}
                    onChange={(numericValue) => {
                      setTerminalPOS({
                        ...terminalPOS,
                        MontoLimite1: numericValue,
                      });
                    }}
                  />
                </InputContainer>

                <InputContainer stacked label="Gubernamental" >
                  <CurrencyInput
                    name="MontoLimite3"
                    placeholder="Límite Gubernamental"
                    value={terminalPOS?.MontoLimite3}
                    onChange={(numericValue) => {
                      setTerminalPOS({
                        ...terminalPOS,
                        MontoLimite3: numericValue,
                      });
                    }}
                  />
                </InputContainer>

                <InputContainer stacked label="Régimen Especial" >
                  <CurrencyInput
                    name="MontoLimite4"
                    placeholder="Límite Régimen Especial"
                    value={terminalPOS?.MontoLimite4}
                    onChange={(numericValue) => {
                      setTerminalPOS({
                        ...terminalPOS,
                        MontoLimite4: numericValue,
                      });
                    }}
                  />
                </InputContainer>
              </SectionRow>
            </EditSection>

          </EditContainer>
        </Form>
      </Col>
    )
  );
};
export default TerminalPOSEdit;